import { locale } from '@/utils/locale';

export const TitanUpgradeBottomAdvertisementHandlerLocale = {
  knowMore: locale('titanAdvertisement.bannerDark.knowMore'),
  description: locale('titanAdvertisement.bannerDark.description'),
  title: locale('titanAdvertisement.bannerDark.title'),
  newTag: locale('titanAdvertisement.bannerDark.newTag'),
};
